import { PricingPlanTier } from 'types/api/companies/contracts'

type PaywallStatusKey =
  | 'PAYMENT_METHOD_DETACHED_PAYMENT_DUE'
  | 'PAYMENT_METHOD_INVALID_PAYMENT_DUE'
  | 'TRIAL_EXPIRED_PAYMENT_METHOD_REQUIRED'
  | 'TRIAL_EXPIRING_SOON'
  | 'PAYMENT_METHOD_INVALID'
  | 'PAYMENT_METHOD_DETACHED'
  | 'PAYMENT_VERIFICATION_PENDING'
  | 'PAYMENT_PENDING'
  | 'CANCELLED_BY_USER'

export type PaywallType =
  | PaywallStatusKey
  | 'SERVICE_LIMIT_REACHED'
  | 'ACCESS_PAYMENT'

export enum PaywallStatusLevel {
  Info = 'info',
  Warning = 'warning',
  Error = 'error'
}

export interface PaywallStatus {
  key: PaywallStatusKey
  message: string
  level: PaywallStatusLevel
}

export enum ContractLimitItem {
  Clients = 'clients',
  Teams = 'teams',
  Services = 'services',
  Users = 'users',
  Targets = 'targets'
}
export type ContractLimits = Partial<Record<ContractLimitItem, number>>

/**
 * For use on non-ts pages that need access to the keys for the ContractLimits
 * interface
 */
export const ContractLimitItemKeys = Object.values(ContractLimitItem)

export interface UserSessionInfo {
  company_id: string
  company_name: string
  company_alias?: string
  company_is_alfi_enabled: boolean
  roles: string[]
  privileges: string[]
  expires_at: string
  header: string
  identifier: string
  first_name: string
  last_name: string
  teams: TeamMembershipInfo[]
  last_login: Date
  renew_token: string
  token: string
  tier: PricingPlanTier
  companyContractExpiresAt: string
  changeRequested: PricingPlanTier
  changeRequestedAt: Date
  changeRequestedBy: string
  company_contract_expires_at: string
  prefs: CompanyPrefs
  has_fault_injection: boolean
  has_reliability_management: boolean
  has_failure_flags: boolean
  is_trial: boolean
  limits: ContractLimits
  paywall_status?: PaywallStatus
}

export interface CompanyPrefs {
  force_mfa: boolean
  auto_add_users: boolean
  monitoring: MonitoringPrefs
  production: boolean
}

export interface TeamMembershipInfo {
  role: string
  roles: string[]
  privileges: string[]
  auto_add_users: boolean
  created_at: string
  identifier: string
  name: string
  company_id: string
  updated_at: string
  certificate_set_at: string
  certificate_set_by: string
  certificate_expires_on: string
  certificate_expiration_imminent: boolean
  production: boolean
}

export interface MonitoringPrefs {
  opt_in: {
    value: boolean
  }
}

export interface MFAResponse {
  enabled: 'true' | 'false'
  provider: string | null
}

export interface UserAuthCompany {
  name: string
  alias?: string
}

export interface UserAuth {
  result: 'chooseCompany' // there may be other values for this
  qrUrl?: string
  secretKey?: string
  companies: UserAuthCompany[]
}
